import { Formik } from 'formik';
import * as yup from 'yup';

import Box from '../../components/layout/Box';
import Details from '../../features/books/form/Details';
import { FormattedMessage } from 'react-intl';
import Text from '../../components/Text';
import FormInput from '../../components/FormInput';
import { Form } from 'react-bootstrap';
import Button from '../../components/Button';
import { useRef } from 'react';

const EditForm = ({
  book,
  completed,
  onUpdate,
  isUpdating,
  showContactError,
}) => {
  const ref = useRef();

  const typeFields = book?.product
    ? {}
    : {
        title: book?.title,
        subtitle: book?.subtitle,
        isbn: book?.isbn,
        author: book?.author,
      };

  const initialValues = {
    ...typeFields,
    price: +book?.price,
    conditionId: +book?.condition?.id || 0,
    comment: book?.comment,
    contactEmail: book?.contactEmail,
    contactPhone: book?.contactPhone,
  };

  const typeValidation = book?.product
    ? {}
    : {
        title: yup.string().required('Obligatoriskt fält').min(2, 'För kort'),
        subtitle: yup.string().min(2, 'För kort'),
        author: yup.string().min(2, 'För kort'),
        isbn: yup.number().integer('ISBN får bara innehålla siffror'),
      };

  const validationSchema = yup.object().shape({
    ...typeValidation,
    price: yup
      .number('Priset måste vara ett tal')
      .required('Obligatoriskt fält')
      .positive('Priset kan inte vara ett negativt belopp')
      .integer('Prister måste vara ett heltal'),
    conditionId: yup.number().required().positive('Obligatoriskt fält'),
  });

  return (
    <Box className="w-100 flex-column">
      <Formik
        innerRef={ref}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onUpdate}
      >
        {({ values, errors, handleChange, submitCount }) => {
          const showErrors = submitCount > 0;

          return (
            <Form>
              {!book?.product && (
                <>
                  <FormInput
                    name="titleInput"
                    value={values.title}
                    onChange={handleChange('title')}
                    label="Titel"
                    error={showErrors && errors.title}
                  />

                  <FormInput
                    name="subtitleInput"
                    value={values.subtitle}
                    onChange={handleChange('subtitle')}
                    label="Undertitel"
                    error={showErrors && errors.subtitle}
                  />

                  <FormInput
                    name="authorInput"
                    value={values.author}
                    onChange={handleChange('author')}
                    label="Författare"
                    error={showErrors && errors.author}
                  />

                  <FormInput
                    name="isbnInput"
                    value={values.isbn}
                    onChange={handleChange('isbn')}
                    label="ISBN"
                    error={showErrors && errors.isbn}
                  />
                </>
              )}

              <Text variant="sectionTitle" className="mt-5 mb-2">
                <FormattedMessage defaultMessage="Pris och skick" />
              </Text>

              <Details
                values={values}
                errors={errors}
                handleChange={handleChange}
                showErrors={showErrors}
                showContactError={showContactError}
              />
            </Form>
          );
        }}
      </Formik>

      <div className="d-flex flex-row-reverse mt-3">
        <Box className="flex-column">
          <Box className="justify-content-end">
            <Button
              onClick={() => ref.current.handleSubmit()}
              isLoading={isUpdating}
              marginTop="l"
              type="submit"
            >
              <FormattedMessage defaultMessage="Uppdatera" />
            </Button>
          </Box>

          {completed && (
            <Text className="mt-2">Ditt inlägg har uppdaterats</Text>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default EditForm;
